<template>
  <div
    v-if="!isLoggedIn"
    class="py-16 flex flex-col items-center justify-center pb-24"
  >
    <h3 class="text-center text-3xl font-semibold text-secondary mb-6">
      {{ $t("homepage.newsletter.title_white") }}
      <span class="text-accent font-bold">{{
        $t("homepage.newsletter.title_red")
      }}</span>
    </h3>
    <div class="w-full md:w-1/2 text-center mb-4">
      <span class="text-secondary">{{
        $t("homepage.newsletter.subtitle")
      }}</span>
    </div>
    <div
      class="
        flex flex-col
        md:flex-row
        items-center
        justify-center
        space-y-3
        md:space-y-0 md:space-x-4
        w-full
        md:w-1/2
      "
    >
      <TextInput
        v-model="email"
        :placeholder="$t('homepage.newsletter.input_placeholder')"
        class="md:w-4/5"
        :error="errors && errors.email ? errors.email[0] : null"
      />
      <MediumButton
        @click="subscribeToNewsletter"
        class="
          bg-secondary
          text-black
          hover:text-secondary
          w-full
          md:w-1/5
          flex
          items-center
          justify-center
        "
        :isLoading="isLoading"
        ><CheckIcon v-if="success" class="h-6 w-6" /><span v-else>{{
          $t("homepage.newsletter.subscribe_button")
        }}</span></MediumButton
      >
    </div>
  </div>
</template>

<script>
import TextInput from "@/components/UI/Inputs/TextInput";
import MediumButton from "@/components/UI/Buttons/MediumButton";
import CheckIcon from "@/components/icons/CheckIcon";
import axios from "axios";
export default {
  name: "NewsletterBlock",
  data() {
    return {
      email: null,
      isLoading: false,
      success: false,
      errors: null,
    };
  },
  components: {
    TextInput,
    MediumButton,
    CheckIcon,
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/loggedIn"];
    },
  },
  methods: {
    subscribeToNewsletter() {
      this.isLoading = true;
      axios
        .post("/newsletter/subscribe", { email: this.email })
        .then(() => {
          this.isLoading = false;
          this.success = true;
        })
        .then(() => {
          this.isLoading = false;
          this.success = true;
          this.email = null;
        })
        .catch((error) => {
          this.isLoading = false;
          this.errors = error.response.data.errors;
        });
    },
  },
};
</script>

<style>
</style>